import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const fmt = (value) => {
  if (value == null || value === "") return "-";
  return String(value);
};

const num = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export function exportStockTransferReportToPDF(transfers, filename = "stock_transfer_report.pdf") {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const addHeader = () => {
    doc.setFillColor(26, 115, 232);
    doc.rect(0, 0, pageWidth, 28, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Stock Transfer Report", 14, 12);
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 20);
    doc.text(`Total Records: ${transfers.length}`, pageWidth - 14, 20, { align: "right" });
    return 34;
  };

  let currentY = addHeader();
  const rows = transfers.map((row, index) => [
    fmt(row.product_details?.name),
    fmt(row.supplier_branch_details?.name || row.supplier_branch_name || row.supplier_branch),
    fmt(row.customer_branch_details?.name || row.customer_branch_name || row.customer_branch),
    fmt(row.transfer_quantity),
    fmt(row.transfer_date),
    fmt(row.status_display || row.status),
    fmt(row.transfer_user_details?.username || row.transfer_user_details?.name),
    num(row.discount_amount ?? row.transfer_discount_amount).toFixed(2),
    num(row.total_amount ?? row.transfer_total_amount).toFixed(2),
    num(row.remained_amount ?? row.total_remained_amount).toFixed(2),
  ]);

  autoTable(doc, {
    head: [["Product", "From Branch", "To Branch", "Qty", "Date", "Status", "User", "Discount Amount", "Total Amount", "Remained Amount"]],
    body: rows,
    startY: currentY,
    theme: "striped",
    styles: {
      fontSize: 8,
      cellPadding: 2,
      valign: "middle",
    },
    headStyles: {
      fillColor: [26, 115, 232],
      textColor: 255,
      fontStyle: "bold",
    },
    margin: { top: 10, left: 6, right: 6 },
    didDrawPage: () => {
      if (doc.internal.getCurrentPageInfo().pageNumber > 1) {
        currentY = addHeader();
      }
    },
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - 14, pageHeight - 8, { align: "right" });
  }

  const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
  doc.save(filename.replace(".pdf", `_${stamp}.pdf`));
}
